<script setup lang="ts">
import { useAuction } from '@autobid/ui/composables/useAuction'
import { useAuctionPagesLink } from '@autobid/ui/composables/useAuctionPagesLink'
import { computed } from 'vue'

interface Props {
  auctionId: number
  appId?: number
}
const props = defineProps<Props>()

const { getLink } = useAuctionPagesLink(props.appId)
const { auction } = useAuction(props.auctionId)
const auctionUrl = computed(() => {
  if (!auction.value?.slug) {
    return
  }

  return getLink({
    page: 'car-list',
    slug: auction.value.slug,
  })
})
</script>

<template>
  <elements-button
    class="all-vehices-btn ml-1.5 !w-auto self-end lg:ml-0"
    :url="auctionUrl"
    :aria-label="$t('car-details.all-vehicles')"
  >
    <span class="hidden lg:block lg:whitespace-nowrap">
      {{ $t('car-details.all-vehicles') }}
    </span>

    <span
      class="relative block text-[var(--auction-banner-all-vehicles-color)] after:absolute after:left-1.5 after:top-1 after:z-10 after:h-8 after:w-8 after:rounded-md after:bg-white lg:hidden"
    >
      <Icon
        mode="css"
        class="relative z-20 block min-w-11"
        name="solar:square-arrow-right-up-linear"
        size="40"
      />
    </span>
  </elements-button>
</template>

<style lang="scss" scoped>
@media (max-width: 1023px) {
  .all-vehices-btn {
    padding: 5px;
    position: relative;
    right: -5px;
    top: 5px;
  }
}
</style>
